import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatiPagamento, ModelInvoice } from 'src/app/entities/invoices';
import { UTILS } from 'src/app/entities/Utils';
import { ConfigProps, ConfigServiceService } from 'src/app/services/config-service/config-service.service';
import { InfoDatoPagamentoComponent } from '../dialog/info-dato-pagamento/info-dato-pagamento.component';
import { UserInfo } from 'src/app/services/login/login.service';
import { IbanAggiuntiviComponent } from '../dialog/iban-aggiuntivi/iban-aggiuntivi.component';

@Component({
  selector: 'app-dati-pagamento',
  templateUrl: './dati-pagamento.component.html',
  styleUrls: ['./dati-pagamento.component.css']
})
export class DatiPagamentoComponent implements OnInit, OnChanges {
  
  @Input() model : ModelInvoice | undefined;
  @Output() modelChange = new EventEmitter<ModelInvoice>();
  @Output() refreshTotali = new EventEmitter<any>();

  public configTabs = {
    selected: 1,
    config: [
      {
        id: 1, 
        name: "Vettore"
      },
      {
        id: 2,
        name: "Altro"
      },
      {
        id: 3,
        name: "Dati Veicolo"
      }
    ]
  }

  configProps : ConfigProps | undefined;

  constructor(private configService: ConfigServiceService, private modalService: NgbModal) { }

  async ngOnInit() {
    this.configProps = new UTILS().deepCopy(await this.configService.getJSON());
    this.configProps!.list.listDivisa.forEach(e => {
      e.label = e.val + " - " + e.label;
    });
    this.configProps!.list.listCausalePagamento.forEach(o => {
      if(o.text!.length > 150){
        o.text = o.text?.substr(0, 150) + "...";
      }
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes.model){
      this.model = changes.model.currentValue;
    }
  }
  public addDatiPagamento(){
    var iban = this.model!.FatturaElettronicaHeader.CedentePrestatore.iban;
    this.model!.FatturaElettronicaBody.DatiPagamento.push(
      {
        CondizioniPagamento:"TP02", 
        DettaglioPagamento: {
          Beneficiario: "",
          ModalitaPagamento: "MP05",
          DataRiferimentoTerminiPagamento: "",
          GiorniTerminiPagamento: "",
          DataScadenzaPagamento: "",
          ImportoPagamento: "",
          CodUfficioPostale: "",
          CognomeQuietanzante: "",
          NomeQuietanzante: "",
          CFQuietanzante: "",
          TitoloQuietanzante: "",
          IstitutoFinanziario: "",
          IBAN: iban,
          ABI: "",
          CAB: "",
          BIC: "",
          ScontoPagamentoAnticipato: "",
          DataLimitePagamentoAnticipato: "",
          PenalitaPagamentiRitardati: "",
          DataDecorrenzaPenale: "",
          CodicePagamento: ""
        }
      }
    )
  }

  public deleteDatoPagamento(index: number){
    this.model!.FatturaElettronicaBody.DatiPagamento.splice(index, 1);
  }

  public async modificaDatoPagamento(mp: DatiPagamento){
    let modalRef = this.modalService.open(InfoDatoPagamentoComponent, {size: 'xl'});
    modalRef.componentInstance.dP = new UTILS().deepCopy(mp);
    let response : DatiPagamento | undefined = await modalRef.result.then(result => {return result;}).catch(err => {return null});
    if(response){
      let indexObj = this.model!.FatturaElettronicaBody.DatiPagamento.indexOf(mp);
      this.model!.FatturaElettronicaBody.DatiPagamento[indexObj] = new UTILS().deepCopy(response);
      this.notifyChange();
    }
  }
  public notifyChange(){
    this.modelChange.emit(this.model);
  }

  public checkIbanMP05(index: number) {
    if (this.model!.FatturaElettronicaBody.DatiPagamento[index].DettaglioPagamento.ModalitaPagamento != 'MP05') {
      this.model!.FatturaElettronicaBody.DatiPagamento[index].DettaglioPagamento.IBAN = '';
    }
  }

  async cercaIbanAggiuntivi(index: number){
    let modalRef = this.modalService.open(IbanAggiuntiviComponent, {size: 'md'});
    let response : string | undefined | null = await modalRef.result.then(result => {return result;}).catch(err => {return null});
    if(response!=undefined && response != null){
        this.model!.FatturaElettronicaBody.DatiPagamento[index].DettaglioPagamento.IBAN=response;
        this.modelChange.emit(this.model);
    }
  }
}
